/**
 * 公共方法hooks
 */
import { IMajorObject } from '@/pages/teachingRoom/types'
import { inject, ref, reactive } from 'vue'
export default () => {
  const { getOrganTree, getAllMajorList, getCaseUserRole, getTeachingGroupList } = inject<any>('$http')
  // 获取机构列表
  const orgProps = reactive({
    checkStrictly: true,
    emitPath: false,
    value: 'id',
    label: 'organName'
  })
  const orgList = ref<any>([])
  const getOrgList = async () => {
    orgList.value = await getOrganTree()
  }

  // 获取选择专业列表
  const majorList = ref<IMajorObject[]>([])
  const getMajorList = async () => {
    const res = await getAllMajorList()
    majorList.value = res
  }

  // 0 游客 1 创建者 2 协作者
  const caseRole = ref(0)
  /**
   * 获取教案案例角色
   * @param siteId
   */
  const getCaseRole = async siteId => {
    const res = await getCaseUserRole(siteId)
    caseRole.value = res
  }

  // 获取所有虚拟教研室
  const courseGroupList = ref([])
  const getAllCourseGroup = async () => {
    const res = await getTeachingGroupList()
    courseGroupList.value = res || []
  }

  return {
    orgProps,
    orgList,
    majorList,
    caseRole,
    courseGroupList,
    getOrgList,
    getMajorList,
    getCaseRole,
    getAllCourseGroup
  }
}
